import moment from 'moment';
import { HTMLAttributes } from 'react';
import SITLogo from '../../../assets/img/sit_logo.png';
import { BaseNotification } from '../../../graphql/generated';

interface DefaultNotificationProps extends HTMLAttributes<HTMLButtonElement> {
  notification: BaseNotification;
  icon?: string;
}

const DescriptionNotification = ({ notification, icon = SITLogo, ...props }: DefaultNotificationProps): JSX.Element => {
  return (
    <button className="notification-container" {...props}>
      <div className="notification">
        <div className="avatar">
          <img alt="avatar" src={icon} />
        </div>
        <div className="details">
          <div className="message">{notification.notification.title}</div>
          <div className="message-description">{notification.notification.body}</div>
          <div className="timestamp">{moment(notification.timestamp).fromNow()}</div>
        </div>
      </div>
    </button>
  );
};

export default DescriptionNotification;
